import React from "react"
import { motion } from "framer-motion"
import { FaFacebookF } from "react-icons/fa"

export const Contact: React.FC = () => {
	return (
		<section id='contact' className='py-10 px-6 bg-primary text-gray-300'>
			<motion.div
				initial={{ y: 50, opacity: 0 }}
				whileInView={{ y: 0, opacity: 1 }}
				viewport={{ once: true }}
				transition={{ duration: 0.5 }}>
				<h3 className='text-3xl font-bold text-center mb-8'>Kontakt</h3>
				<div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
					{/* Address Column */}
					<div>
						<h4 className='text-xl font-bold mb-4'>Adres</h4>
						<p>ul. Sienkiewicza 14a/2</p>
						<p>58-200 Dzierżoniów</p>
					</div>
					{/* Contact Column */}
					<div>
						<h4 className='text-xl font-bold mb-4'>Kontakt</h4>
						<p>
							Telefon:{" "}
							<a href='tel:+48693530800' className='hover:underline'>
								+48 693 530 800
							</a>
						</p>
						<p>
							Email:{" "}
							<a href='mailto:biuro@ep-uslugi.pl' className='hover:underline'>
								biuro@ep-uslugi.pl
							</a>
						</p>
					</div>
					{/* Social Media Column */}
					<div>
						<h4 className='text-xl font-bold mb-4'>Media społecznościowe</h4>
						<a
							href='https://www.facebook.com'
							target='_blank'
							rel='noopener noreferrer'
							className='flex items-center space-x-2 hover:underline'>
							<FaFacebookF />
							<span>Facebook</span>
						</a>
					</div>
				</div>
			</motion.div>
		</section>
	)
}
